// Copied/adapted from `pdt-old/listing.helper.ts` (do not modify old files).

import {
  mapSearchContextToXdm,
  createPageContext,
  createEventDetail,
  createEventTrackingContext,
  type SearchArgumentsForXdm,
} from './pdtToXdm.mapper';
import { getJourneyId, type BasicSearchContext } from './utils';
import { EVENT_NAMES, EVENT_TYPES, PAGE_VALUES } from './constants';

const toBasicSearchContext = (
  searchArguments: SearchArgumentsForXdm,
): BasicSearchContext => {
  const date = searchArguments.date || null;
  const departureDate = date
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
        date.getDate(),
      ).padStart(2, '0')}`
    : '';

  return {
    originCityCode: searchArguments.from.code || '',
    destinationCityCode: searchArguments.to.code || '',
    departureDate,
  };
};

export const createListingPageLoadEvent = ({
  searchArguments,
}: {
  searchArguments: SearchArgumentsForXdm;
}) => {
  const searchContext = toBasicSearchContext(searchArguments);
  const journeyId = getJourneyId(searchContext);

  return {
    page_context: createPageContext({
      pageName: searchArguments.pageName ?? 'listing',
      prevPageName: null,
      pageTitle: typeof document !== 'undefined' ? document.title : null,
      pageUrl: typeof window !== 'undefined' ? window.location.href : null,
    }),
    search_context: mapSearchContextToXdm({ searchArguments }),
    event_detail: createEventDetail({
      eventName: EVENT_NAMES.PAGE_RENDERED,
      eventType: EVENT_TYPES.LIFE_CYCLE,
      eventValue: PAGE_VALUES.LISTING,
    }),
    event_tracking_context: createEventTrackingContext({
      journeyId,
    }),
  };
};
